import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3f5f21ae&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../less/complex.less?vue&type=style&index=0&id=3f5f21ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f21ae",
  null
  
)

export default component.exports